import React, { useEffect } from "react"
import { Layout as AntdLayout } from "antd"
import { createUseStyles } from "react-jss"
import { Outlet, useLocation } from "react-router-dom"
import Header, { ListProps } from "./header/Header"
import { Paths } from "../router/paths"

const { Content } = AntdLayout

const useStyles = createUseStyles({
    layout: {
        background: "#ffffff"
    },
    content: {
        margin: "0",
        padding: 24,
        minHeight: 280
    },
    "@media (min-width: 1200px)": {
        content: {
            margin: "0",
            padding: 24,
            minHeight: 280
        }
    }
})

const Layout = () => {
    const classes = useStyles()
    const location = useLocation()

    const list: ListProps[] = [
        {
            title: "Настройка интеграции 1С Зуп",
            link: Paths.main,
            hidden: false
        },
        {
            title: "Сотрудники",
            link: Paths.employees,
            hidden: false
        },
        {
            title: "Роли",
            hidden: false,
            children: [
                {
                    title: "Роли 1С Зуп",
                    link: Paths.oneCZupRoles,
                    hidden: false
                },
                {
                    title: "Роли iiko",
                    link: Paths.iikoRoles,
                    hidden: false
                }
            ]
        },
        {
            title: "Департаменты",
            hidden: false,
            children: [
                {
                    title: "Департаменты 1С Зуп",
                    link: Paths.oneCZupDepartments,
                    hidden: false
                },
                {
                    title: "Департаменты iiko",
                    link: Paths.iikoDepartments,
                    hidden: false
                },
                {
                    title: "Департаменты iSpring",
                    link: Paths.iSpringDepartments,
                    hidden: false
                }
            ]
        }
    ]


    useEffect(() => {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }, [location])

    return (
        <AntdLayout className={classes.layout}>
            <Header list={list} />
            <Content className={classes.content}>
                <Outlet />
            </Content>
        </AntdLayout>
    )
}

export default Layout
